import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { Reveal, Eyebrow } from "./Decorative";
import { PERFORM, UPCOMING_EDITION } from "../lib/constants";
import { ROUTES } from "../lib/seo";
import { trackPerformClick } from "../lib/track";

/**
 * Home-page entry point to the dancers' open call.
 *
 * Renders nothing when PERFORM.open is false, so closing the call is a
 * one-line change in constants.js rather than an edit in three files. The
 * page itself stays live for anyone holding the URL.
 *
 * scripts/verify-content.js fails the build if no page links to /perform/
 * while the call is open, so this band going missing is caught at deploy.
 */
export default function PerformBand() {
  if (!PERFORM.open) return null;
  return (
    <section className="bg-[#120C08] py-20 md:py-24 px-6" data-testid="perform-band">
      <div className="max-w-4xl mx-auto text-center">
        <Reveal>
          <Eyebrow>Open call</Eyebrow>
          <h2 className="mt-4 font-display text-3xl md:text-4xl leading-[1.1] text-[#F5EFE6]">
            There is room on the stage
          </h2>
          <p className="mt-5 font-body text-base md:text-lg text-[#E8D9C5]/85 leading-relaxed max-w-2xl mx-auto">
            {PERFORM.blurb} Send us a video, and dance at {UPCOMING_EDITION.venue}{" "}
            in {UPCOMING_EDITION.city} in front of a full hall. Applications are
            open until {PERFORM.deadlineLabel}.
          </p>
          <Link
            to={ROUTES.perform.path}
            onClick={trackPerformClick}
            className="mt-8 cta-primary"
            data-testid="perform-band-btn"
          >
            <Sparkles size={18} strokeWidth={1.6} />
            <span>See the open call</span>
            <span className="cta-arrow">→</span>
          </Link>
          <p className="mt-3 font-body text-sm" style={{ color: "#C9A961" }}>
            An unpaid showcase. We do not pay performers, and we do not charge them.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
